import styled, { css, keyframes } from 'styled-components';
import { THEME } from '@/common/styles/theme';

const slideIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(10px);
	}

	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

export const MessageBubble = styled.div`
	max-width: 76%;
	border-radius: 18px;
	padding: 12px 14px;
	line-height: 1.45;
	color: #f8edf3;
	backdrop-filter: blur(14px);
	animation: ${slideIn} 0.2s ease-out;
	word-wrap: break-word;

	${(props) =>
		props.isSender
			? css`
					align-self: flex-end;
					background: linear-gradient(
						135deg,
						rgba(176, 38, 255, 0.82),
						rgba(255, 77, 242, 0.72)
					);
					box-shadow: 0 0 18px rgba(255, 77, 242, 0.18);
				`
			: css`
					align-self: flex-start;
					background: rgba(255, 255, 255, 0.075);
					border: 1px solid rgba(255, 255, 255, 0.055);
				`}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		max-width: 88%;
		border-radius: 14px;
		padding: 8px 11px;
		font-size: 0.875rem;
		line-height: 1.4;
	}
`;

export const MessageRow = styled.div`
	display: flex;
	flex-direction: column;
	align-items: ${({ $isSender }) => ($isSender ? 'flex-end' : 'flex-start')};
	width: 100%;
`;
